export default {
  validBookingResourceSkuAssociation(draggedData, targetData) {
    if (!targetData.handle.startsWith("transfer-person")) {
      return false;
    }

    switch (draggedData.type) {
      case "transfer":
        return draggedData.handle.startsWith("transfer-other");

      case "flight":
        return [null, undefined, ""].includes(
          targetData.bookingResourceSkuTransferFlightId
        );

      default:
        return false;
    }
  },
};
